/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientReferralViewRecipient } from './RecipientReferralViewRecipient';
import {
    RecipientReferralViewRecipientFromJSON,
    RecipientReferralViewRecipientFromJSONTyped,
    RecipientReferralViewRecipientToJSON,
    RecipientReferralViewRecipientToJSONTyped,
} from './RecipientReferralViewRecipient';
import type { ReferralType } from './ReferralType';
import {
    ReferralTypeFromJSON,
    ReferralTypeFromJSONTyped,
    ReferralTypeToJSON,
    ReferralTypeToJSONTyped,
} from './ReferralType';

/**
 * 
 * @export
 * @interface RecipientReferralView
 */
export interface RecipientReferralView {
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    sender_facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    sender_facility_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    last_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RecipientReferralView
     */
    dob?: Date | null;
    /**
     * 
     * @type {ReferralType}
     * @memberof RecipientReferralView
     */
    referral_type?: ReferralType | null;
    /**
     * 
     * @type {Date}
     * @memberof RecipientReferralView
     */
    target_discharge_date?: Date | null;
    /**
     * 
     * @type {RecipientReferralViewRecipient}
     * @memberof RecipientReferralView
     */
    recipient: RecipientReferralViewRecipient;
}



/**
 * Check if a given object implements the RecipientReferralView interface.
 */
export function instanceOfRecipientReferralView(value: object): value is RecipientReferralView {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('recipient' in value) || value['recipient'] === undefined) return false;
    return true;
}

export function RecipientReferralViewFromJSON(json: any): RecipientReferralView {
    return RecipientReferralViewFromJSONTyped(json, false);
}

export function RecipientReferralViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientReferralView {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'sender_facility_id': json['sender_facility_id'],
        'sender_facility_name': json['sender_facility_name'] == null ? undefined : json['sender_facility_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'dob': json['dob'] == null ? undefined : (new Date(json['dob'])),
        'referral_type': json['referral_type'] == null ? undefined : ReferralTypeFromJSON(json['referral_type']),
        'target_discharge_date': json['target_discharge_date'] == null ? undefined : (new Date(json['target_discharge_date'])),
        'recipient': RecipientReferralViewRecipientFromJSON(json['recipient']),
    };
}

export function RecipientReferralViewToJSON(json: any): RecipientReferralView {
    return RecipientReferralViewToJSONTyped(json, false);
}

export function RecipientReferralViewToJSONTyped(value?: RecipientReferralView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'sender_facility_id': value['sender_facility_id'],
        'sender_facility_name': value['sender_facility_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'] == null ? undefined : ((value['dob'] as any).toISOString().substring(0,10)),
        'referral_type': ReferralTypeToJSON(value['referral_type']),
        'target_discharge_date': value['target_discharge_date'] == null ? undefined : ((value['target_discharge_date'] as any).toISOString().substring(0,10)),
        'recipient': RecipientReferralViewRecipientToJSON(value['recipient']),
    };
}

